module.exports = __webpack_public_path__ + "static/img/spc.fdefe5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/spc.png
// module id = rBDG
// module chunks = 0